
import Button from '@/components/Button.vue'
import Icon from '@/components/Icon.vue'
import { events } from '@/config'
import useRequest from '@/hooks/useRequest'
import { cancel } from '@/modules/trade/trade.api'
import DialogTemplate from '@/views/DialogTemplate.vue'
import { emit } from 'essential/tools/event'
import { defineComponent, shallowRef } from 'vue'

export default defineComponent({
  name: 'TheCommissionCancelConfirmDialog',
  components: { Icon, Button, DialogTemplate },
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  setup (props, ctx) {
    const done = shallowRef(false)

    const [commit, progress] = useRequest(cancel)
    return {
      done,
      close () {
        ctx.emit('close')
      },
      submit () {
        return commit({ orderId: props.order.orderId })
          .then(() => {
            emit('transactionUpdateCommission')
            done.value = true
            setTimeout(() => {
              ctx.emit('close')
            }, 2000)
          })
      },
      progress,
    }
  },
})
